import type { Signal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

/** The slice of the host's current-user state the assistant needs. */
export interface TellentAssistantCurrentUserData {
  userName: Signal<string>;
  userGuid: Signal<string | null>;
  memberGuid: Signal<string | null>;
}

export const {
  provide: provideTellentAssistantCurrentUserData,
  inject: injectTellentAssistantCurrentUserData,
} = createProviderToken<TellentAssistantCurrentUserData>('TELLENT_ASSISTANT_CURRENT_USER_DATA')(
  false,
);
